export default "__VITE_ASSET__BaH1r1tP__"